import { env as getEnv } from 'next-runtime-env';
const env = getEnv("NEXT_PUBLIC_THEANIMATOR_ENV");

console.log(`Loading ${env || "dev"} config...`);

const envConfig = Object.freeze(require(`../../config/${env || "dev"}.json`));

export default envConfig;
